import i18n from "i18next";
import * as Yup from "yup";

export const EmailValidation = () => {
  return Yup.string()
    .email(i18n.t("formFields.emailErrors.invalid", { ns: "formFields" }))
    .test(
      "email-requires-tld",
      i18n.t("formFields.emailErrors.invalid", { ns: "formFields" }),
      (value) => {
        if (!value) return true;
        const parts = value.split("@");
        return parts.length === 2 && !!parts[1]?.includes(".");
      },
    )
    .required(i18n.t("formFields.emailErrors.required", { ns: "formFields" }));
};
